import { supportedMetricWindowing } from '@gonfalon/dogfood-flags/dogfood-flags';

const LD_HOSTED_WINDOWING_PIPELINES = ['chex', 'grinch'];

export const ldHostedWindowingEnabled = () => {
  const pipelines: unknown = supportedMetricWindowing();
  return Array.isArray(pipelines) && pipelines.some((pipeline) => LD_HOSTED_WINDOWING_PIPELINES.includes(pipeline));
};
